import { notify } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { login as apiLogin } from "../../../api";
import logo from "../../../media/branding/logoLight.png";
import { login, logout } from "../../../redux/reducers/session/actions";
import getErrorMessage from "../../../utils/getErrorMessage";
import { TypedLoginPage } from "../../../utils/typedLib";

interface LoginCredentials {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const { t } = useTranslation("auth", { keyPrefix: "login" });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async ({ email, password }: LoginCredentials) => {
    try {
      const { data } = await apiLogin(email, password);
      const { jwt, user } = data;

      dispatch(login(jwt, { ...user, id: user?.id ?? null, email: user?.email ?? "" }));

      switch (user?.role?.name) {
        case "Admin": {
          // const [stores] = await storeRequests.getList()
          // dispatch(setStore(stores?.[0], stores))
          break;
        }
        case "Authenticated": {
          // if(!managedStore) return dispatch(logout())
          // const [store] = await storeRequests.get(managedStore.id)
          // if(store) dispatch(setStore(store, [store]));
          // else dispatch(logout())
          break;
        }
        case "Not verified": {
          // if(!managedStore) return dispatch(logout())
          // const [store] = await storeRequests.get(managedStore.id)
          // if(store) dispatch(setStore(store, [store]));
          // else dispatch(logout())
          break;
        }
        default:
          throw new Error("Unauthorized");
      }

      notify.success(t("successMessage"), { icon: <i className="fas fa-handshake ni-lg" /> });
    } catch (err: unknown) {
      notify.error(getErrorMessage(err, "Error"));
      dispatch(logout());
    }
  };

  return (
    <TypedLoginPage
      emailPlaceholder={t("emailPlaceholder")}
      forgottenPasswordText={t("forgottenPasswordText")}
      invalidEmailFeedbackText={t("invalidEmailFeedbackText")}
      invalidPasswordFeedbackText={t("invalidPasswordFeedbackText")}
      lead={t("lead")}
      onClickForgottenPassword={() => navigate("/auth/forgotten-password")}
      onClickRegister={() => navigate("/auth/signup")}
      onSubmit={onSubmit}
      passwordPlaceholder={t("passwordPlaceholder")}
      registerText={t("registerText")}
      rememberLabel={t("rememberLabel")}
      submitText={t("submitText")}
      title={
        <>
          <span>{t("welcomeTo")}</span>
          <img src={logo} alt="" className="mt-1 mb-3" style={{ width: 600, maxWidth: "100%" }} />
        </>
      }
      showRegisterAsButton
    />
  );
};

export default Login;
